namespace JupitersChoice {
    export class AudioConstants {
        public static BASE_MUSIC_VOLUME: number = 0.35;
        public static BASE_MUSIC_WIN_VOLUME: number = 0.3;
        public static BASE_SFX_VOLUME: number = 0.6;

        public static SPIN_BUTTON_VOLUME: number = 0.4;

        public static BG_WIN_MUSIC_DELAY: number = 15;

        public static LOCK_LIGHTNING_VOLUME: number = 0.7;

        public static MEGAHIT_LIGHTNING_VOLUME: number = 1;

        public static BIG_WIN_VOLUME: number = 0.7;

        public static WHEEL_WOOSH_VOLUME: number = 0.7;
    }
}